import {
    ActiveProblems
  } from 'one-state-activeproblems/src/activeproblems';
import { formatIso } from 'one-util-date';  
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Active Problems Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */

export const sortFunction = (a: ActiveProblems, b: ActiveProblems) => {
    const dateA = new Date(a.dateNoted);
    const dateB =new Date(b.dateNoted);
    return dateB.getTime() - dateA.getTime();
}

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    // let result: ActiveProblems[] = [];
    let result :any = {
        activeproblems:[],
        error:undefined
    }
    const { log,settings } = context;
    const {uisettings:{dateformat}} = settings
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }
   
    if (response && response.length > 0) {
        const rs = response;
        let activeprobs:ActiveProblems[]=[]
        rs.map((ele: any) => {
            let activeprobobj : ActiveProblems ={
                id :"",
                dateNoted:"",
                problemName:""
            }
            activeprobobj.problemName = ele.ProblemName;
            activeprobobj.dateNoted = ele.DateNoted ? formatIso(ele.DateNoted, dateformat):'';

            activeprobs.push(activeprobobj);
        });
        result.activeproblems=activeprobs;
    }
    log.debug(
        "ccw-gadget,activeproblem-epic",
        "activeproblem-epic transforamtion response ", {
        result
    });
    result.activeproblems.sort(sortFunction);
    return result;
}